export default __webpack_public_path__ + "static/media/keyboard.b754664e.jpg";